import http from 'hub-http/clients/apiClient';
import { makeSimpleQuickFetchWrapper } from '../utils/ajaxUtils';
const API_BASE = '/customer-portal/settings/v1';
export default class CustomerPortalApi {}
CustomerPortalApi.get = makeSimpleQuickFetchWrapper('get-cp', () => http.get(API_BASE));